"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lt = void 0;
const lt = ({ leftValue, rightValue, }) => {
    if (leftValue === null || leftValue === undefined) {
        return { error: null, result: false };
    }
    if (rightValue === null || rightValue === undefined) {
        return { error: null, result: false };
    }
    if (Array.isArray(leftValue) || Array.isArray(rightValue)) {
        return {
            error: `Invalid comparison for less than: array provided as value`,
        };
    }
    const result = leftValue < rightValue;
    return { error: null, result };
};
exports.lt = lt;
//# sourceMappingURL=lt.js.map